import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, AbstractControlOptions } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiCallService } from '../../services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Constanst } from '../../constants/constans.component';
import { HelperClassService } from '../../services/clase-utilidades.services';
import { ComparePassword } from '../../constants/confirmed.validator';

class SaveNewPassword {
  userName: string;
  pregunta: string;
  passwordForgot: string;
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  logoColegioIngenieros = Constanst.LOGO_COLEGIO_INGENIEROS;
  logoDatalaing = Constanst.LOGO_DATALAING;
  messageError: string = '';
  hide = true;
  hideResponseQuestion = true;
  hideTextPassword = true;
  hideTextConfirmPassword = true;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  listQuestion: any[];
  randomQuestion = '';
  idRandomQuestion = 0;
  messageDialog: string = '';
  resultDialog: string = '';

  modelSaveNewPassword: SaveNewPassword = {
    userName: '',
    pregunta: '',
    passwordForgot: '',
    password: '',
    confirmPassword: ''
  };

  userForm = this.formBuilder.group({
    username: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
  });

  userPasswordForm = this.formBuilder.group({
    pregunta: ['', [Validators.required, Validators.minLength(4)]],
    passwordForgot: ['', [Validators.required, Validators.minLength(6), Validators.pattern(Constanst.REGEXP_PASSWORD)]],
    confirmForgot: ['', [Validators.required, Validators.minLength(6), Validators.pattern(Constanst.REGEXP_PASSWORD)]],
  },
    {
      validators: ComparePassword('passwordForgot', 'confirmForgot')
    } as AbstractControlOptions
  );

  constructor(
    private router: Router,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private formBuilder: FormBuilder,
  ) { }
  classFlag = false;
  ngOnInit(): void {
    if (screen.width <= 400) {
      this.classFlag = true;
    } else {
      this.classFlag = false;
    } 
  }

  validateUser() {
    if (this.userForm.invalid) {
      return;
    } else {
      return this.getSecurityQuestion();
    }
  }

  getSecurityQuestion() {
    this.listQuestion = [];
    this.route = '/getSecurityQuestionByUser';
    this.method = 'POST';
    let data = {
      username: this.userForm.value.username,
    }

    this.apiCallService.showSpinner();
    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        this.apiCallService.hideSpinner();
        if (response.status === Constanst.RESPONSE_STATUS_ERROR) {
          this.hide = true;
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USERNAME_DOES_NOT_EXIST, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        } else {
          this.listQuestion = response;
          const random = Math.floor(Math.random() * this.listQuestion.length);
          this.randomQuestion = this.listQuestion[random].description;
          this.idRandomQuestion = this.listQuestion[random].idSecurityQuestion;
          this.hide = false;
        }
      });
  }

  validatePassword() {
    if (this.userPasswordForm.invalid) {
      return;
    } else {
      return this.validateChangePassword();
    }
  }

  validateChangePassword() {
    const dialogConfirm = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_PASSWORD, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialogConfirm.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/validateResponseSecurityByUser';
        this.method = 'POST';
        let data = {
          username: this.userForm.value.username,
          newPassword: this.userPasswordForm.value.confirmForgot,
          idFirstSecurityQuestion: this.idRandomQuestion,
          responseFirstQuestion: this.userPasswordForm.value.pregunta
        }
        //console.log(data);
        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              //console.log(response);
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.userForm.value.username = '';
                this.idRandomQuestion = 0;
                this.messageDialog = Constanst.MSG_PASSWORD_CHANGED;
                this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;
              } else {
                switch (response.data.code) {
                  case 'MSG-011': {
                    this.messageDialog = Constanst.MSG_011;
                    break;
                  } default: {
                    this.messageDialog = Constanst.MSG_GENERIC_ERROR;
                  }
                }
                this.resultDialog = Constanst.DIALOG_RESULT_ERROR;
              }
              this.apiCallService.hideSpinner();
              const dialog = this.helperClassService.openDialogGeneric('25rem', true, this.messageDialog, false, true, false, '', '', '', this.resultDialog);
              dialog.afterClosed().subscribe(() => {
                if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                  this.router.navigate(['/login']);
                }
              });
            },
            error => {
              //console.log('Falla al guardar la clave ', error)
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            });
      } else {
        dialogConfirm.close(false);
      }
    });
  }

  forgotAnswers() {
    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_009, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
  }

}
